var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _vm.showChat
      ? _c("div", { staticClass: "ai-chat-wrapper" }, [
          _c("div", { staticClass: "ai-chat-window" }, [
            _c(
              "div",
              { staticClass: "chat-header" },
              [
                _c("span", [_vm._v("Select Bot :")]),
                _vm._v(" "),
                _c(
                  "el-radio-group",
                  {
                    staticClass: "bot-selector",
                    model: {
                      value: _vm.selectedBot,
                      callback: function($$v) {
                        _vm.selectedBot = $$v
                      },
                      expression: "selectedBot"
                    }
                  },
                  [
                    _c("el-radio", { attrs: { label: "1" } }, [
                      _vm._v("Teacher User")
                    ]),
                    _vm._v(" "),
                    _c("el-radio", { attrs: { label: "2" } }, [
                      _vm._v("Centre User")
                    ])
                  ],
                  1
                ),
                _vm._v(" "),
                _c("i", {
                  staticClass: "el-icon-close",
                  on: { click: _vm.toggleChat }
                })
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "chat-body" },
              _vm._l(_vm.messages[_vm.selectedBot], function(msg, index) {
                return _c("div", { key: index, staticClass: "chat-message" }, [
                  msg.role === "ai"
                    ? _c("div", { staticClass: "message ai-message" }, [
                        _vm._m(0, true),
                        _vm._v(" "),
                        _c("div", { staticClass: "message-content" }, [
                          _c("div", { staticClass: "message-time" }, [
                            _vm._v(
                              _vm._s(
                                _vm
                                  .moment(msg.time)
                                  .format("DD/MM/YYYY HH:mm:ss")
                              )
                            )
                          ]),
                          _vm._v(" "),
                          _c("div", {
                            staticClass: "message-text",
                            domProps: { innerHTML: _vm._s(msg.content) }
                          })
                        ])
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  msg.role === "user"
                    ? _c("div", { staticClass: "message user-message" }, [
                        _c("div", { staticClass: "message-content" }, [
                          _c("div", { staticClass: "message-time" }, [
                            _vm._v(
                              _vm._s(
                                _vm
                                  .moment(msg.time)
                                  .format("DD/MM/YYYY HH:mm:ss")
                              )
                            )
                          ]),
                          _vm._v(" "),
                          _c("div", {
                            staticClass: "message-text",
                            domProps: { innerHTML: _vm._s(msg.content) }
                          })
                        ]),
                        _vm._v(" "),
                        _vm._m(1, true)
                      ])
                    : _vm._e()
                ])
              }),
              0
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "chat-footer" },
              [
                _c("el-input", {
                  attrs: {
                    type: "textarea",
                    autosize: { minRows: 2, maxRows: 4 },
                    placeholder: "Please enter your message..."
                  },
                  nativeOn: {
                    keydown: function($event) {
                      if (
                        !$event.type.indexOf("key") &&
                        _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                      ) {
                        return null
                      }
                      $event.preventDefault()
                      return _vm.handleEnter($event)
                    }
                  },
                  model: {
                    value: _vm.userInput,
                    callback: function($$v) {
                      _vm.userInput = $$v
                    },
                    expression: "userInput"
                  }
                }),
                _vm._v(" "),
                _vm.selectedBot == 1
                  ? _c("button", { on: { click: _vm.sendMessage } }, [
                      _vm._v("\n          Send\n          "),
                      _c("i", { staticClass: "el-icon-s-promotion" })
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _vm.selectedBot == 2
                  ? _c("button", { on: { click: _vm.sendCentreMessage } }, [
                      _vm._v("\n          Send\n          "),
                      _c("i", { staticClass: "el-icon-s-promotion" })
                    ])
                  : _vm._e()
              ],
              1
            )
          ])
        ])
      : _vm._e(),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "bottom-right-bot", on: { click: _vm.toggleChat } },
      [_c("i", { staticClass: "el-icon-chat-line-round input-icon" })]
    )
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "message-avatar" }, [
      _c("i", { staticClass: "el-icon-s-custom avatar-icon" })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "message-avatar" }, [
      _c("i", { staticClass: "el-icon-user-solid avatar-icon" })
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }